import { useDataSubmit } from 'Simple/Data.js'

export function useOnSubmit(props) {
  let submit = useDataSubmit({
    context: 'itero_scan',
    viewPath: props.viewPath,
  })

  return function onSubmit() {
    return submit({ type: 'download' })
  }
}
